import styled from "styled-components";

export const Container = styled.div`
  padding: 2rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-height: 200px;
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  border-radius: 1rem;
  gap: 1rem;
`;

export const Grid = styled.div`
  gap: 1rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: stretch;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;